import { useNavigate, useParams } from 'react-router-dom'

import { EmptyState } from './components/Feedback'
import { IssueDetail } from './IssueDetail'
import { useWorkspace } from './useWorkspace'

/**
 * The issue at its own URL — the link people paste into chat.
 *
 * Route it as `/app/issues/:issueKey` or, if the shell scopes routes by
 * workspace, `/app/orgs/:slug/issues/:issueKey`; both resolve here because the
 * slug falls back to the session's active workspace.
 */
export default function IssuePage() {
  const params = useParams()
  const navigate = useNavigate()
  const { slug } = useWorkspace()
  const issueRef = params.issueKey ?? params.key ?? null

  if (!issueRef) {
    return <EmptyState title="No issue selected" description="This URL is missing an issue key." />
  }

  return (
    <div className="mx-auto h-full max-w-6xl">
      <IssueDetail
        slug={slug}
        issueRef={issueRef}
        layout="page"
        onOpenIssue={(next) => navigate(`../${next}`, { relative: 'path' })}
        onDeleted={() => navigate(-1)}
      />
    </div>
  )
}
